module.exports = "/_next/static/images/MattLutton-7e823d4937977e80d656e57a3d4a2b2d.webp";